import socket from '../../../api/socket';

// Sincronizar usuario de Clerk con el backend
export default async (userData) => {
  try {
    // Obtener token de Clerk desde localStorage
    const clerkToken = localStorage.getItem('clerkToken');

    if (!clerkToken) {
      throw new Error('No Clerk token found');
    }

    // Llamar al backend para sincronizar/crear usuario usando socket
    const response = await socket.post('/users/clerk-sync', {
      clerkUserId: userData.clerkUserId,
      email: userData.email,
      name: userData.name,
      username: userData.username,
      organizationId: userData.organizationId,
    }, {
      'Authorization': `Bearer ${clerkToken}`,
    });

    return response.item;
  } catch (error) {
    console.error('Error syncing Clerk user with backend:', error);
    throw error;
  }
};
